module.exports = __webpack_public_path__ + "static/rcc-os-icon-4423f0795d6a407c8c942cbab653e856.png";